import lift, { ArrayOps } from '../lift';
/**
 * Folds this Array into a single value, using a starting value, from the right.
 */
export function foldRight(startValue, func) {
    var arr = this.value(), result = startValue, i = arr.length;
    while (i--) {
        result = func(result, arr[i], i);
    }
    return typeof result === 'boolean' ? result : lift(result);
}
ArrayOps.prototype.foldRight = foldRight;
